const style = {
  underline: {
    '&:before': {
      borderBottom: '0 !important',
    },
  },
};

export default style;
